import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30990e64"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "listPage" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "listContent" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "listText" };
const _hoisted_6 = { class: "drawTime flex" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "drawName" }, "抽奖时间", -1));
const _hoisted_8 = { class: "timeDetail" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "listText" };
const _hoisted_11 = { class: "drawTime noStartTime flex" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "drawName" }, "抽奖时间", -1));
const _hoisted_13 = {
    class: "timeDetail",
    style: { "color": "#484848" }
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "listText" };
const _hoisted_16 = { style: { "color": "#808080" } };
const _hoisted_17 = { class: "drawTime endTime flex" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "drawName",
    style: { "background": "#a0a0a0" }
}, "抽奖时间", -1));
const _hoisted_19 = {
    class: "timeDetail",
    style: { "color": "#484848" }
};
const _hoisted_20 = { class: "noMore" };
import { getDepId } from '@/api/user';
import { getActivityList } from '@/api/mall';
import { getUserId, jumpModuleApp, setWebBackground } from '@/widget';
import { hostPath } from '@/public/utils/basePath';
import Header from '@/components/common/Header.vue';
import { appPort, closeWebView, hiddenAppNavBar } from '@/widget/index';
import { onMounted, ref, nextTick, getCurrentInstance } from 'vue';
import Empty from '@/components/common/Empty.vue';
import BScroll from '@/components/common/BetterScroll.vue';
import { Toast } from 'vant';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const route = useRoute();
        const isApp = ref(appPort());
        const depId = ref(1);
        const listData = ref([]);
        const noMore = ref(false);
        const listBs = ref(); // 上拉加载
        let loaded = ref(false); // 是否加载完成
        var pageNo = 1;
        const userId = ref(getUserId());
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                location.href = `${hostPath}/mall`;
            }
        };
        const getList = () => {
            $showLoading();
            loaded.value = false;
            getActivityList({
                params: {
                    userId: userId.value,
                    depId: depId.value
                },
                query: {
                    pageNo,
                    pageSize: 10
                }
            }).then(res => {
                $hideLoading();
                if (res.code === 200) {
                    const pageCount = res.data.pageCount;
                    if (pageCount === 1) {
                        listData.value = res.data.list;
                    }
                    else {
                        listData.value = listData.value.concat(res.data.list);
                    }
                    loaded.value = true;
                    if (pageNo >= pageCount) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo++;
                    }
                }
            });
        };
        const goDetail = (type, id) => {
            if (type === 1) {
                location.href = `/learn/mall/raffle/${id}`;
            }
            else if (type === 0) {
                Toast('活动未开始');
            }
            else {
                Toast('活动已结束');
            }
        };
        const goRecord = () => {
            if (isApp.value) {
                jumpModuleApp({
                    url: `${hostPath}/learn/mall/raffle/record`,
                    typeId: 'h5'
                });
            }
            else {
                location.href = '/learn/mall/raffle/record';
            }
        };
        /* 获取用户科室id */
        const getUseDep = () => {
            getDepId(userId.value).then(res => {
                if (res.code === 200) {
                    depId.value = res.data.depId;
                    nextTick(() => {
                        getList();
                    });
                }
            });
        };
        onMounted(() => {
            if (isApp.value) {
                /* app里隐藏头部 */
                hiddenAppNavBar();
                setWebBackground('ff3c47');
            }
            if (route.query.depId) {
                depId.value = Number(route.query.depId);
                getList();
            }
            else {
                getUseDep();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isLight: true,
                    border: false,
                    pageTitle: '抽奖列表'
                }, {
                    shareBtn: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "clickEntry",
                            onClick: _withModifiers(goRecord, ["stop"])
                        }, "我的奖品", 8, _hoisted_2)
                    ]),
                    _: 1
                }),
                _createVNode(BScroll, {
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                        listBs.value = _value;
                    },
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: true,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    loaded: _unref(loaded),
                    noMore: noMore.value,
                    onUpLoad: getList,
                    domStyle: {
                        position: 'relative',
                        height: `calc(100vh - 0.88rem)`
                    }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (item.status == 1)
                                        ? (_openBlock(), _createElementBlock("li", {
                                            key: 0,
                                            class: "starting",
                                            onClick: _withModifiers(($event) => (goDetail(1, item.activityId)), ["stop"])
                                        }, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("p", null, _toDisplayString(item.activityName), 1),
                                                _createElementVNode("div", _hoisted_6, [
                                                    _hoisted_7,
                                                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.startDate) + "-" + _toDisplayString(item.endDate), 1)
                                                ])
                                            ])
                                        ], 8, _hoisted_4))
                                        : (item.status == 0)
                                            ? (_openBlock(), _createElementBlock("li", {
                                                key: 1,
                                                class: "noStart",
                                                onClick: _withModifiers(($event) => (goDetail(0, item.activityId)), ["stop"])
                                            }, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("p", null, _toDisplayString(item.activityName), 1),
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _hoisted_12,
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.startDate) + "-" + _toDisplayString(item.endDate), 1)
                                                    ])
                                                ])
                                            ], 8, _hoisted_9))
                                            : (_openBlock(), _createElementBlock("li", {
                                                key: 2,
                                                class: "endBg",
                                                onClick: _withModifiers(($event) => (goDetail(2, item.activityId)), ["stop"])
                                            }, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("p", _hoisted_16, _toDisplayString(item.activityName), 1),
                                                    _createElementVNode("div", _hoisted_17, [
                                                        _hoisted_18,
                                                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.startDate) + "-" + _toDisplayString(item.endDate), 1)
                                                    ])
                                                ])
                                            ], 8, _hoisted_14))
                                ], 64));
                            }), 128)),
                            _withDirectives(_createElementVNode("div", _hoisted_20, "没有更多了", 512), [
                                [_vShow, noMore.value && listData.value.length]
                            ]),
                            (listData.value.length == 0 && _unref(loaded))
                                ? (_openBlock(), _createBlock(Empty, { key: 0 }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["loaded", "noMore", "domStyle"])
            ]));
        };
    }
});
